import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton } from '@shared/ui';
import { Loader } from '@shared/ui/CustomModal/ui/Loader/Loader';

import { ModalBodyUpdateInfoAboutObject } from './ModalBodyUpdateInfoAboutObject/ModalBodyUpdateInfoAboutObject';
import cls from './ModalUpdateInfoAboutObject.module.css';
import { useModalUpdateInfoAboutObject } from './useModalUpdateInfoAboutObject';

interface UpdateInfoAboutObjectProps {
    classes?: string;
}

export const ModalUpdateInfoAboutObject = memo(({ classes }: UpdateInfoAboutObjectProps) => {
    const {
        form,
        onForm,
        onCoordinates,
        onSubmit,
        onCancel,
        modalMode,
        editLoader,
        handleAddressSubmit,
        mapCenter,
    } = useModalUpdateInfoAboutObject();

    const { t } = useTranslation();

    return (
        <CustomModal
            contentClasses={cls.modal}
            isOpen={modalMode === 'editInformation'}
            onHideModal={onCancel}
        >
            {editLoader && <Loader variant="light" />}
            <CustomModal.Header>
                {t('ModalUpdateInfoAboutObject.return.modalHeader')}
            </CustomModal.Header>
            <CustomModal.Body>
                <ModalBodyUpdateInfoAboutObject
                    form={form}
                    onForm={onForm}
                    onCoordinates={onCoordinates}
                    handleAddressSubmit={handleAddressSubmit}
                    mapCenter={mapCenter}
                />
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex fullWidth justify="between">
                    <UiButton
                        onClick={onCancel}
                        btnColor="secondary"
                        btnText={t('ModalUpdateInfoAboutObject.return.modalFooter.cancel')}
                    />
                    <UiButton
                        onClick={onSubmit}
                        btnText={t('ModalUpdateInfoAboutObject.return.modalFooter.submit')}
                    />
                </Flex>
            </CustomModal.Footer>
        </CustomModal>
    );
});
